import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { EmailClipModule } from '@platform-frontend/account-ui';
import { DrawDialogModule } from '@platform-frontend/checkout';
import { LegalModule } from '@platform-frontend/platform';
import {
  IconsModule,
  LanguageChooserModule,
  LinkModule,
  NotificationModule,
  TabSelectableModule,
  TemplateVariablesModule,
  TooltipModule
} from '@platform-frontend/ui-tools';
import { RouterExtensionsModule } from '@platform-frontend/util';
import { MatomoTrackClickDirective } from 'ngx-matomo-client';
import { TranslocoMarkupModule } from 'ngx-transloco-markup';
import { BottomRowComponent } from './bottom-row/bottom-row.component';
import { ErrorComponent } from './error/error.component';
import { SimpleHeaderComponent } from './simple-header/simple-header.component';

@NgModule({
  declarations: [BottomRowComponent, ErrorComponent, SimpleHeaderComponent],
  imports: [
    CommonModule,
    EmailClipModule,
    IconsModule,
    LanguageChooserModule,
    LegalModule,
    LinkModule,
    MatomoTrackClickDirective,
    NotificationModule,
    RouterExtensionsModule,
    RouterModule,
    TabSelectableModule,
    TemplateVariablesModule,
    TooltipModule,
    TranslocoMarkupModule,
    TranslocoModule,
    DrawDialogModule
  ],
  exports: [BottomRowComponent, ErrorComponent, SimpleHeaderComponent]
})
export class LayoutModule {}
